import { createContext, useContext } from 'react';
import noop from 'utils/noop';

type TabContextState = {
  selectedTab: string;
  hideTabContentBackground: boolean;
  showTabs: boolean;
  showLocationTab: boolean;
  showDeviceTab: boolean;
  showSnippetTab: boolean;
  setSelectedTab: (selectedTab: string) => void;
};

export const defaultTabState: TabContextState = {
  selectedTab: 'overview',
  hideTabContentBackground: false,
  showTabs: false,
  showLocationTab: false,
  showDeviceTab: false,
  showSnippetTab: false,
  setSelectedTab: noop,
};

export const TabContext = createContext<TabContextState>(defaultTabState);

export const useTabContext = () => useContext(TabContext);
